module.exports = __webpack_public_path__ + "img/logo-razer.519ae637.png";